/**
 * 返回带重定向参数的登录 URL
 *
 * @param redirectPath - 登录后需要跳转的路径
 * @param fromPage - 来源页面类型（用于埋点）
 * @returns 格式化后的登录 URL 字符串
 */
export function getLoginUrl(redirectPath?: string, fromPage?: string): string {
  const params = new URLSearchParams();
  if (redirectPath) {
    params.set('redirect', redirectPath);
  }
  if (fromPage) {
    params.set('from_page', fromPage);
  }
  const queryString = params.toString();
  return queryString ? `/login?${queryString}` : '/login';
}
